export default __webpack_public_path__ + "static/media/ThumbsDownIcon.331d47d1.svg";